import { trackingVirtualPageView } from '@/tracking/tracking';
import { VirtualPageViewProps } from '@/tracking/types';
import { useStore } from 'vuex';

export function useTrackingVirtualPageView() {
  const store = useStore();

  const trackVirtualPageView = ({
    subType,
    locale,
    stepInputs,
    moreParams,
  }: VirtualPageViewProps) => {
    const sourceFromStore = store.getters?.['common/getHowSource'];
    const hasSourceParam = moreParams && Object.hasOwn(moreParams, 'h_conversion_source_061');

    const mergedParams = {
      ...(!hasSourceParam && sourceFromStore && { h_conversion_source_061: sourceFromStore }),
      ...moreParams,
    };

    trackingVirtualPageView({
      subType,
      locale,
      stepInputs,
      ...(Object.keys(mergedParams).length && { moreParams: mergedParams }),
    });
  };

  return {
    trackVirtualPageView,
  };
}
